import * as C from "../constants/jewelryHireConstants";

const EMPTY_LIST = {
  items: [],
  page: 1,
  pages: 0,
  count: 0,
};

export const jewelryHireListReducer = (state = EMPTY_LIST, action) => {
  switch (action.type) {
    case C.JEWELRY_HIRE_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case C.JEWELRY_HIRE_LIST_SUCCESS:
      return {
        loading: false,
        items: action.payload?.items || [],
        page: action.payload?.page || 1,
        pages: action.payload?.pages || 0,
        count: action.payload?.count || 0,
      };
    case C.JEWELRY_HIRE_LIST_FAIL:
      return { ...EMPTY_LIST, loading: false, error: action.payload };
    case C.JEWELRY_HIRE_LIST_RESET:
      return EMPTY_LIST;
    default:
      return state;
  }
};

export const jewelryHireDetailsReducer = (state = { item: null }, action) => {
  switch (action.type) {
    case C.JEWELRY_HIRE_DETAILS_REQUEST:
      return { item: null, loading: true, error: null };
    case C.JEWELRY_HIRE_DETAILS_SUCCESS:
      return { item: action.payload, loading: false };
    case C.JEWELRY_HIRE_DETAILS_FAIL:
      return { item: null, loading: false, error: action.payload };
    case C.JEWELRY_HIRE_DETAILS_RESET:
      return { item: null };
    default:
      return state;
  }
};

export const adminJewelryHireListReducer = (state = EMPTY_LIST, action) => {
  switch (action.type) {
    case C.ADMIN_JEWELRY_HIRE_LIST_REQUEST:
      return { ...state, loading: true, error: null };
    case C.ADMIN_JEWELRY_HIRE_LIST_SUCCESS:
      return {
        loading: false,
        items: action.payload?.items || [],
        page: action.payload?.page || 1,
        pages: action.payload?.pages || 0,
        count: action.payload?.count || 0,
      };
    case C.ADMIN_JEWELRY_HIRE_LIST_FAIL:
      return { ...EMPTY_LIST, loading: false, error: action.payload };
    case C.ADMIN_JEWELRY_HIRE_LIST_RESET:
      return EMPTY_LIST;
    default:
      return state;
  }
};

export const adminJewelryHireDetailsReducer =
  (state = { item: null }, action) => {
    switch (action.type) {
      case C.ADMIN_JEWELRY_HIRE_DETAILS_REQUEST:
        return { item: null, loading: true, error: null };
      case C.ADMIN_JEWELRY_HIRE_DETAILS_SUCCESS:
        return { item: action.payload, loading: false };
      case C.ADMIN_JEWELRY_HIRE_DETAILS_FAIL:
        return { item: null, loading: false, error: action.payload };
      case C.ADMIN_JEWELRY_HIRE_DETAILS_RESET:
        return { item: null };
      default:
        return state;
    }
  };

function buildMutationReducer(types) {
  return (state = {}, action) => {
    switch (action.type) {
      case types.request:
        return { loading: true };
      case types.success:
        return { loading: false, success: true, item: action.payload };
      case types.fail:
        return { loading: false, error: action.payload };
      case types.reset:
        return {};
      default:
        return state;
    }
  };
}

export const adminJewelryHireCreateReducer = buildMutationReducer({
  request: C.ADMIN_JEWELRY_HIRE_CREATE_REQUEST,
  success: C.ADMIN_JEWELRY_HIRE_CREATE_SUCCESS,
  fail: C.ADMIN_JEWELRY_HIRE_CREATE_FAIL,
  reset: C.ADMIN_JEWELRY_HIRE_CREATE_RESET,
});

export const adminJewelryHireUpdateReducer = buildMutationReducer({
  request: C.ADMIN_JEWELRY_HIRE_UPDATE_REQUEST,
  success: C.ADMIN_JEWELRY_HIRE_UPDATE_SUCCESS,
  fail: C.ADMIN_JEWELRY_HIRE_UPDATE_FAIL,
  reset: C.ADMIN_JEWELRY_HIRE_UPDATE_RESET,
});

export const adminJewelryHireDeleteReducer = buildMutationReducer({
  request: C.ADMIN_JEWELRY_HIRE_DELETE_REQUEST,
  success: C.ADMIN_JEWELRY_HIRE_DELETE_SUCCESS,
  fail: C.ADMIN_JEWELRY_HIRE_DELETE_FAIL,
  reset: C.ADMIN_JEWELRY_HIRE_DELETE_RESET,
});
